var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRenameIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66683 14.0007L9.3335 11.334H13.3335C13.7002 11.334 14.0142 11.4644 14.2755 11.7253C14.5364 11.9867 14.6668 12.3007 14.6668 12.6673C14.6668 13.034 14.5364 13.348 14.2755 13.6093C14.0142 13.8702 13.7002 14.0007 13.3335 14.0007H6.66683ZM2.66683 12.6673H3.60016L9.35016 6.91732L8.41683 5.98398L2.66683 11.734V12.6673ZM12.2002 5.95065L9.36683 3.15065L10.3002 2.21732C10.5557 1.96176 10.8697 1.83398 11.2422 1.83398C11.6142 1.83398 11.9279 1.96176 12.1835 2.21732L13.1168 3.15065C13.3724 3.40621 13.5057 3.71465 13.5168 4.07598C13.5279 4.43687 13.4057 4.7451 13.1502 5.00065L12.2002 5.95065ZM2.00016 14.0007C1.81127 14.0007 1.65305 13.9367 1.5255 13.8087C1.3975 13.6811 1.3335 13.5229 1.3335 13.334V11.4507C1.3335 11.3618 1.35016 11.2758 1.3835 11.1927C1.41683 11.1091 1.46683 11.034 1.5335 10.9673L8.40016 4.10065L11.2335 6.93398L4.36683 13.8007C4.30016 13.8673 4.22527 13.9173 4.14216 13.9507C4.05861 13.984 3.97238 14.0007 3.8835 14.0007H2.00016ZM8.8835 6.45065L8.41683 5.98398L9.35016 6.91732L8.8835 6.45065Z",
    fill: "#654AFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRenameIcon);
export default __webpack_public_path__ + "static/media/rename-icon.2a7860a7a83c667eb3d3f7073e842d62.svg";
export { ForwardRef as ReactComponent };